import TrendHeader from "./Header";
import "./Header.scss";

export default TrendHeader;